import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("li", { class: "complete" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("li", { class: "active" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("li", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", {
  value: "docs",
  selected: ""
}, "ドキュメントテンプレート", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "slide" }, "スライドテンプレート", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "stickynote" }, "ふせん", -1)
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressStep = _resolveComponent("ProgressStep")!
  const _component_Button = _resolveComponent("Button")!
  const _component_AppContent = _resolveComponent("AppContent")!

  return (_openBlock(), _createBlock(_component_AppContent, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_ProgressStep, null, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", {
        class: _normalizeClass({ fontRed: !_ctx.isValid })
      }, "どのテンプレートを集計するか選択してください", 2),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectType) = $event)),
        style: {"width":"30%","margin":"10px"},
        class: _normalizeClass({ bkRed: !_ctx.isValid }),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isValid = true))
      }, _hoisted_7, 34), [
        [_vModelSelect, _ctx.selectType]
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          onClick: _ctx.toInputUrl,
          type: "line"
        }, {
          default: _withCtx(() => [
            _createTextVNode("戻る")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          onClick: _ctx.setParam,
          type: "fill"
        }, {
          default: _withCtx(() => [
            _createTextVNode("次へ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}